// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Kb","content":"Lb","hasOpenedNav":"Mb","crumbsList":"Nb","dropdownsWrap":"Ob"};